import { FC } from 'react';
import { Reference } from 'types/reference';
import Image, { FrontasticImage } from '../../atoms/image';
import Link from '../../atoms/link';
import Typography from '../../atoms/typography';

export interface AdvertisementProps {
  image: Pick<FrontasticImage, 'media'>;
  heading: string;
  buttonLabel?: string;
  buttonLink?: Reference;
}

export const Advertisement: FC<AdvertisementProps> = ({
  image,
  heading,
  buttonLabel,
  buttonLink,
}: AdvertisementProps) => {
  return (
    <div className="relative w-full sm:h-100 sm:min-h-full">
      <Image media={image.media} className="absolute size-full object-cover" />
      <div className="container z-10 h-full">
        <div className="flex h-full flex-col items-center justify-between gap-x-16 gap-y-32 py-32 sm:flex-row md:gap-x-32">
          <Typography as="h2" className="body-text-medium text-inverted">
            {heading}
          </Typography>
          {!!buttonLabel && !!buttonLink && (
            <Link
              link={buttonLink}
              buttonVariant="secondary-inverted"
              /* Had to force with ! here since the button always use text-base and size classes are hard to redo right now in the buttonClassNames of Link */
              className="max-h-44 w-full whitespace-nowrap !p-8 text-center !text-14 leading-4 sm:w-auto sm:min-w-fit md:!px-24 md:!py-12 md:!text-16"
            >
              {buttonLabel}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
